import { mergeAttributes, Node} from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react'
//@ts-ignore
import remixiconUrl from 'remixicon/fonts/remixicon.symbol.svg'

const FactBoxComponent = () => {

  return (
    <NodeViewWrapper className="bg-gray-300 p-3 mt-3 rounded-md">
      <span className="relative -top-6" contentEditable={false}>
        <svg className="rounded-full w-10 h-10 bg-white mx-auto">
          <use xlinkHref={`${remixiconUrl}#ri-information-fill`} />
        </svg>
      </span>

      <NodeViewContent />
    </NodeViewWrapper>
  )

}

export interface FactBoxOptions {
  /**
   * Custom HTML attributes that should be added to the rendered HTML tag.
   */
  HTMLAttributes: Record<string, any>,
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    factbox: {
      /**
       * Toggle a fact box
       */
       toggleFactBox: (attributes?: { backgroundColor: string }) => ReturnType,
    }
  }
}

const FactBox = Node.create<FactBoxOptions>({
  name: 'factbox',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  content: 'block+',

  group: 'block',

  defining: true,

  addNodeView() {
    return ReactNodeViewRenderer(FactBoxComponent)
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'factbox',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0
    ]
  },

  addCommands() {
    return {
      toggleFactBox: attributes => ({ commands }) => {
        return commands.toggleWrap(this.name, attributes)
      },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Alt-F': () => this.editor.commands.toggleFactBox(),

      // remove fact box when at start of document or factbox is empty
      Backspace: () => {
        const { empty, $anchor } = this.editor.state.selection
        const isAtStart = $anchor.pos === 1

        if (!empty || $anchor.parent.type.name !== this.name) {
          return false
        }

        if (isAtStart || !$anchor.parent.textContent.length) {
          return this.editor.commands.clearNodes()
        }

        return false
      },
    }
  },
})

export default FactBox